import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OrganizationSelectComponent } from './organization-select.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatSelectModule, MatOptionModule, MatAutocompleteModule],
  exports: [OrganizationSelectComponent],
  declarations: [OrganizationSelectComponent]
})
export class OrganizationSelectModule {}
